import { create } from 'zustand';
import { ParticipantRole } from '@/consts/meeting.ts';
import { combine } from 'zustand/middleware';

interface UserState {
  userUid: string;
  userName: string;
  isAuthenticated: boolean;
  role: ParticipantRole | undefined;
  participantActiveCanvas: 'canvasFile' | 'canvasBoard';
}

interface UserActions {
  setUserUid: (userUid: string) => void;
  setUserName: (userName: string) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setRole: (role: ParticipantRole | undefined) => void;
  setParticipantActiveCanvas: (canvas: 'canvasFile' | 'canvasBoard') => void;
}

export const useUserStore = create(
  combine<UserState, UserActions>(
    {
      userUid: '',
      userName: '',
      isAuthenticated: false,
      role: undefined,
      participantActiveCanvas: 'canvasFile'
    },
    (set) => ({
      setUserUid: (userUid) => set({ userUid }),
      setUserName: (userName) => set({ userName }),
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setRole: (role) => set({ role }),
      setParticipantActiveCanvas: (participantActiveCanvas) => set({ participantActiveCanvas })
    })
  )
);
